export default {
    'br.com.azi.hal.usuario.exception.CpfJaExisteException': {
        mensagem: 'O CPF informado já está sendo utilizado por outro usuário.',
    },
}
